<template>
  <el-submenu index="Comn_culture" v-if="canShowSubMenuItem">
    <template slot="title">{{ $t("Comn_culture") }}</template>
    <router-link
      v-for="(item, key) in filterMenuItemsByPermissions"
      :key="key"
      :to="item.route"
      class="menu-item-wrapper"
    >
      <li
        class="el-menu-item"
        :class="{ 'is-active': $route.meta.langKey === item.langKey }"
        :index="item.langKey"
        :route="item.route"
      >
        <img class="menu-image" :src="renderMenuIcon(item.imgKey)" />
        <p class="menu-title truncate" v-if="getSideNavStatus">
          {{ $t(item.langKey) }}
        </p>
      </li>
    </router-link>
  </el-submenu>
</template>

<script>
import { mapGetters } from "vuex";
import renderMenuIcon from "./renderMenuIcon";
import { permissionsToStringMap as permissions } from "@/middleware/pageAccessManager";
export default {
  computed: {
    ...mapGetters("header", {
      getSideNavStatus: "getSideNavStatus"
    }),
    menuItems: function() {
      return {
        FEEDING: {
          langKey: "Comn_feeding",
          route: "/user/feeding?tab=pmFeedingTab",
          imgKey: "FEEDING",
          keyToValidateAccess: "PERMISSIONS",
          PERMISSIONS: [
            permissions.MANAGE_CULTURE,
            permissions.MANAGE_SCHEDULES
          ]
        },
        MEDICINE: {
          langKey: "Comn_culture_medicine",
          route: "/user/culture-medicine",
          imgKey: "MEDICINE",
          keyToValidateAccess: "PERMISSIONS",
          PERMISSIONS: [permissions.MANAGE_MEDICINE]
        },
        ABW: {
          langKey: "ABW_abw",
          route: "/user/abw",
          imgKey: "ABW",
          keyToValidateAccess: "PERMISSIONS",
          PERMISSIONS: [permissions.MANAGE_ABW]
        },
        LAB_TESTS: {
          langKey: "LabTst_lab_test",
          route: "/user/lab-tests",
          imgKey: "LAB_TESTS",
          keyToValidateAccess: "PERMISSIONS",
          PERMISSIONS: [permissions.MANAGE_LAB_TESTS]
        },
        YIELD: {
          langKey: "Comn_yield",
          route: "/user/yield",
          imgKey: "YIELD",
          keyToValidateAccess: "PERMISSIONS",
          PERMISSIONS: [permissions.MANAGE_HARVEST]
        }
      };
    },
    filterMenuItemsByPermissions: function() {
      return this.itemsUserCanView(this.menuItems);
    },
    canShowSubMenuItem: function() {
      return Object.keys(this.filterMenuItemsByPermissions).length > 0;
    }
  },
  methods: {
    renderMenuIcon
  }
};
</script>

<style></style>
